import { FacilitatorDetails, FacilitatorListKeys } from "../../model";
import { ReactNode } from "react";
import { useSiteCore } from "../../../../../../../../../../hooks/useSiteCore";

import {
  Column,
  MuiOptionMenu,
  MuiTable,
  RowProps,
} from "../../../../../../../../../../components";
import { facilitatorSiteCoreKeys } from "../../SiteCoreKeys";
import {
  MenuItemConfig,
  TableActionType,
  TableActions,
} from "../../../../../../../../../../helpers/types/common";
import {
  MODULE_PERMISSIONS,
  PAGE_IDS,
} from "../../../../../../../../../../helpers/constants";
import { buildActionMenuItems } from "../../../../../../../../../../helpers/utils";
import { usePermissions } from "../../../../../../../../../../hooks/usePermissions";

const {
  facilitator,
  facilitatorFunctionTableColumn,
  facilitatorTableColumn,
  facilitatorAssignedDateTableColumn,
  facilitatorActionTableColumn,
} = facilitatorSiteCoreKeys;

interface FacilitatorListProps {
  facilitatorList: FacilitatorDetails[];
  isViewOnly?: boolean;
  dateFormat: string;
  onActionClick?: (
    action: TableActionType,
    selectedFacilitator: FacilitatorDetails,
  ) => void;
}
export const FacilitatorList = ({
  facilitatorList,
  onActionClick,
  isViewOnly = false,
  dateFormat,
}: FacilitatorListProps) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  const getLabel = (key: string) => {
    return fetchLabel(facilitator, key);
  };
  const emptyTableMessage = commonLabels.noRecordsFound;

  const { hasModulePermission } = usePermissions();

  const columns: Column[] = [
    {
      id: FacilitatorListKeys.functionName,
      label: getLabel(facilitatorFunctionTableColumn),
      isSortVisible: true,
    },
    {
      id: FacilitatorListKeys.facilitatorName,
      label: getLabel(facilitatorTableColumn),
      isSortVisible: true,
    },
    {
      id: FacilitatorListKeys.assignmentDate,
      label: getLabel(facilitatorAssignedDateTableColumn),
      isSortVisible: true,
    },
    ...(isViewOnly
      ? []
      : [
          {
            id: "action",
            label: getLabel(facilitatorActionTableColumn),
            render: (row: RowProps) => {
              const configs: MenuItemConfig<RowProps>[] = [
                {
                  permissionKey: MODULE_PERMISSIONS.PROJECT_EDIT_FACILITATOR,
                  create: (r) => ({
                    label: commonLabels.delete,
                    dataTestId: "delete",
                    onClick: () =>
                      onActionClick?.(
                        TableActions.delete,
                        r as FacilitatorDetails,
                      ),
                  }),
                },
              ];

              const menuItems = buildActionMenuItems(
                row,
                configs,
                hasModulePermission,
              );

              return menuItems ? <MuiOptionMenu menuItems={menuItems} /> : null;
            },
          },
        ]),
  ];
  return (
    <MuiTable
      pageId={PAGE_IDS.PROJECT_FACILITATOR}
      tableHeaderForm={[]}
      columns={columns}
      tableResults={facilitatorList as unknown as Record<string, ReactNode>[]}
      noDataInApi={facilitatorList.length === 0}
      emptyMessage={emptyTableMessage}
      noResultMessage={commonLabels.searchCriteria}
      priorityResults={[]}
      isFooterVisible={false}
    />
  );
};
